
/**
 * getListingNameFromStream - returns the proper string representation for the listing.name.
 * Depending on the entitlements and packages available, it will append the feedName to the name.
 *
 * @param  {Object} listing - Object containing all metadata for the current listing
 * @param  {string[]} packageNamesList - Array containing the current packages associated with the listing
 * @param  {string[]} entitlementsList - Array containing the current entitlements
 * @return {string}
 */
export default function getListingNameFromStream(listing = {}) {
    const name = (listing.name && listing.name !== '') ? listing.name.trim() : '';
    const feedName = listing.feedName || '';

    if (feedName !== '') {
        return `${name} (${feedName})`;
    }

    return name;
};



// WEBPACK FOOTER //
// ./app/lib/format/getListingNameFromStream.js